import { defineStore } from 'pinia'
import { MessageAPI } from '@/services/message'
import { ref } from 'vue'
export const useReportStore = defineStore('report', () => {
  const reportTypeList = ref<any[]>([])
  const isLoading = ref(false)
  const getReportType = async () => {
    // 有数据时不加载接口
    if (reportTypeList.value.length > 0) return
    isLoading.value = true
    try {
      const res = await MessageAPI.reportType()
      reportTypeList.value = res.data
    } finally {
      isLoading.value = false
    }
  }
  return {
    reportTypeList,
    isLoading,
    getReportType
  }
})
